<!-- Copyright 2019, Nathan Lecompte -->

<template>
    <a class="res-item" :href="item.url" rel="noopener noreferrer" :title="item.title" v-if="item.title&&item.desc&&item.url">
        <h2>{{ item.title }}</h2>
        <p>{{ item.desc }}</p>
        <span>
            <img :src="item.icon" alt="favicon"/> {{ item.url }} — {{ item.engine }}
        </span>
    </a>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>